import React from "react";
import MuiInputAdornment from "@mui/material/InputAdornment";
import PropTypes from "prop-types";

/**
 * InputAdornment component wrapper for text field adornments.
 * Wraps Material-UI InputAdornment for consistent imports.
 * 
 * @component
 * @example
 * <InputAdornment position="start">
 *   <Icon>search</Icon>
 * </InputAdornment>
 */
const InputAdornment = ({ children, ...props }) => {
  return <MuiInputAdornment {...props}>{children}</MuiInputAdornment>;
};

InputAdornment.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The position this adornment should appear relative to the Input
   */
  position: PropTypes.oneOf(["start", "end"]).isRequired,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * Disable typography
   */
  disableTypography: PropTypes.bool,
  /**
   * The variant to use
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"]),
};

export default InputAdornment;
